import { createContext } from 'react';

import { LayoutType } from '../../provider/PageLayoutProvider/constants';

import type { PageLayoutStateContextParams } from '../../provider/PageLayoutProvider/types';

const initialStateContext = {
  layoutType: LayoutType.list,
};

const PageLayoutStateContext = createContext<PageLayoutStateContextParams>(initialStateContext);

export { initialStateContext as initialPageLayoutStateContext, PageLayoutStateContext };
